import { ResponseError } from "~/error";

export const fetcher = async (url: string, init?: RequestInit) => {
	const res = await fetch(url, init);

	// If the status code is not in the range 200-299,
	// we still try to parse and throw it.
	if (!res.ok) {
		throw new ResponseError(
			"An error occurred while fetching the data.",
			res.status,
			await res.json(),
		);
	}

	return res.json();
};
